import React, { useEffect, useState } from "react";
import "./desktop-overlay.css";

const DesktopOverlay = ({ minWidth = 1025 }) => {
  const getState = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isPortrait = height > width;
    const isTabletPortrait = width >= 768 && width <= minWidth && isPortrait;
    const isMobileOrSmall = width < 768;

    return {
      blocked: width <= minWidth,
      isTabletPortrait,
      isMobileOrSmall
    };
  };

  const [state, setState] = useState(getState);

  useEffect(() => {
    const onResize = () => {
      setState(getState());
    };

    // Listen to both resize and orientation change events
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);

    // Also check on mount in case initial state was wrong
    onResize();

    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, [minWidth]);

  if (!state.blocked) return null;

  return (
    <div
      className="desktop-overlay"
      role="dialog"
      aria-modal="true"
      onWheel={(e) => e.preventDefault()}
      onTouchMove={(e) => e.preventDefault()}
    >
      <div className="desktop-overlay__content">
        {state.isTabletPortrait ? (
          <>
            <h1>Please rotate your device</h1>
            <p>
              This app works best in landscape mode. Please rotate your tablet to continue.
            </p>
          </>
        ) : (
          <>
            <h1>Please view on desktop</h1>
            <p>
              This app isn't available on tablet or mobile resolutions.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default DesktopOverlay;